import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ExcelModule, PDFModule } from '@progress/kendo-angular-grid';
import { ExcelExportModule } from "@progress/kendo-angular-excel-export";
import { MatStepperModule } from '@angular/material/stepper';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CustomModule } from '@app/custom/custom.module';
import { QuotingModule } from '@quoting/quoting.module';
import { SharedModule } from '@app/shared/shared.module';
import { MaterialModule } from '@app/app.material.module';
import { RenewalsCustomRoutingModule } from './renewals-custom-routing.module';
import { MatrixService } from '@app/matrix/services/matrix.service';
import { WizardBarModule } from '@app/wizard-bar/wizard-bar.module';
import { RenewalsCustomContractDetailsComponent } from './pages/renewals-custom-contract-details/renewals-custom-contract-details.component';
import { RenewalsCustomCustomerDetailsComponent } from './pages/renewals-custom-customer-details/renewals-custom-customer-details.component';
import { RenewalsCustomFileValidationComponent } from './pages/renewals-custom-file-validation/renewals-custom-file-validation.component';
import { RenewalsCustomGetQuoteComponent } from './pages/renewals-custom-get-quote/renewals-custom-get-quote.component';
import { RenewalsCustomSupplyDetailsComponent } from './pages/renewals-custom-supply-details/renewals-custom-supply-details.component';
import { RenewalsCustomUtilityAccountsComponent } from './pages/renewals-custom-utility-accounts/renewals-custom-utility-accounts.component';
import { RenewalsCustomYoureDoneComponent } from './pages/renewals-custom-youre-done/renewals-custom-youre-done.component';
import { FileManagementModule } from '@app/filemanagement/file-management.module';
import { RenewalsFixDataComponent } from './components/renewals-fix-data/renewals-fix-data-component';
import { RenewalsCustomConsumptionUploadComponent } from './pages/renewals-custom-consumption-upload/renewals-custom-consumption-upload.component';

@NgModule({
  declarations: [
    RenewalsCustomContractDetailsComponent,
    RenewalsCustomCustomerDetailsComponent,
    RenewalsCustomFileValidationComponent,
    RenewalsCustomGetQuoteComponent,
    RenewalsCustomSupplyDetailsComponent,
    RenewalsCustomUtilityAccountsComponent,
    RenewalsCustomYoureDoneComponent,
    RenewalsFixDataComponent,
    RenewalsCustomConsumptionUploadComponent
],
  imports: [
    ExcelModule,
    PDFModule,
    ExcelExportModule,
    CommonModule,
    SharedModule,
    MaterialModule,
    RenewalsCustomRoutingModule,
    InlineSVGModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatCheckboxModule,
    MatDialogModule,
    MatSelectModule,
    MatIconModule,
    MatPaginatorModule,
    WizardBarModule,
    MatStepperModule,
    MatCardModule,
    MatFormFieldModule,
    CustomModule,
    QuotingModule,
    FileManagementModule
  ],
  providers: [MatrixService]
})
export class RenewalsCustomModule { }
